// extracted by mini-css-extract-plugin
export default {"home":"Home_home__4+lMs","table":"Home_table__KfiOa"};